import React, { memo } from 'react';
import styles from './TextAction.scss';

const TextAction = ({ icon, text, onClick }) => {
    return (
        <div onClick={onClick} className={styles.TextActionWrapper} data-cy="TextAction">
            <div className={styles.TextAction}>
                {icon && <span className={styles.TextAction__Icon}>{icon}</span>}
                <span data-cy="TextAction-text">{text}</span>
            </div>
        </div>
    );
};

export default memo(TextAction);
